<template>
  <div class="contact-section">
    <div class="contact-section__wrapper">
      <z-title size="large" color="inverted" align="center">
        Ainda tem alguma dúvida? <br>Chama a gente
      </z-title>
      <div class="contact__content">
        <z-icon size="giant" color="inverted" :icon="['fab', 'whatsapp']" tag="span" />
        <div class="contact__info">
          <z-text size="large" color="inverted" align="center">
            WhatsApp
          </z-text>
          <z-text size="large" color="inverted" align="center" weight="bold">
            0800 291 7878
          </z-text>
        </div>
      </div>
      <z-button
        tag="a"
        href="https://api.whatsapp.com/send?phone=558002917878"
        @click.native="clickedWhatsapp()"
        target="_blank"
        brand="undergraduate"
        size="medium"
      >
        Enviar uma mensagem
      </z-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickedWhatsapp() {
      this.$tracker.logEvent('[Landing] Clicked Whatsapp');
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-section {
  background-color: var(--color-primary);
  padding: var(--space-extra-colossal) var(--space-medium);;
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    padding: var(--space-jumbo) var(--space-medium);
  }
}

.contact-section__wrapper {
  margin: 0 auto;
  max-width: 1140px;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}

.contact__content {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-medium);
  margin-top: var(--space-jumbo);
}

.contact__info {
  display: inline-block;
}
</style>
